var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4.5V8h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v6H2V2a2 2 0 0 1 2-2h5.5L14 4.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.818 12.75h-2.925v2.65h-1.322V9h4.613v1.007h-3.29v1.74h2.924v1.002ZM5.173 15.4V9H6.94c.316 0 .611.037.886.11.275.07.525.171.75.303.197.109.372.242.525.4.156.155.292.325.408.51.134.226.238.475.31.747.074.273.112.563.112.87v.528c0 .296-.034.576-.103.84a2.98 2.98 0 0 1-.29.725 3.145 3.145 0 0 1-.418.545c-.16.164-.334.302-.525.413a2.836 2.836 0 0 1-.736.303c-.266.07-.55.106-.853.106H5.173ZM6.5 10.002v4.405h.506c.162 0 .314-.02.455-.057a1.322 1.322 0 0 0 .703-.457c.097-.12.18-.26.248-.418.056-.138.099-.29.127-.457a3.04 3.04 0 0 0 .047-.55v-.536c0-.185-.016-.36-.047-.523a2.154 2.154 0 0 0-.127-.457 1.608 1.608 0 0 0-.272-.44 1.39 1.39 0 0 0-.384-.316 1.486 1.486 0 0 0-.375-.141 1.74 1.74 0 0 0-.44-.053H6.5ZM1.317 13.053V15.4H0V9h2.334c.372 0 .708.051 1.008.154.3.1.556.239.769.417.21.182.37.399.483.651.115.252.173.532.173.84a1.829 1.829 0 0 1-.656 1.424 2.31 2.31 0 0 1-.769.417c-.3.1-.636.15-1.008.15H1.317Zm0-1.003h1.017c.188 0 .35-.026.488-.079a1.01 1.01 0 0 0 .347-.215.866.866 0 0 0 .201-.312c.047-.12.07-.245.07-.374 0-.15-.023-.288-.07-.417a.922.922 0 0 0-.201-.339.997.997 0 0 0-.347-.228 1.295 1.295 0 0 0-.488-.084H1.317v2.048Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.3a075833411b34ee43c0cd28ce20c29f.svg";
export { ForwardRef as ReactComponent };